module.exports = __webpack_public_path__ + "img/Mescyt.5bd25dc7.svg";